module.exports = __webpack_public_path__ + "img/Vector 384 (3).cce1ab04.png";